import ServiceDetailLayout from "@/components/site/ServiceDetailLayout";

export default function CampaignOps() {
  return (
    <ServiceDetailLayout
      eyebrow="Campaign Operations"
      title="Campaign execution support for teams that need speed without losing quality."
      subtitle="Launch emails, landing pages, webinars, nurture programs, gated content, and paid campaign flows with a structured campaign operations partner."
      cta="Book a Working Session"
      seo={{
        title: "Campaign Operations Agency | Email, Landing Pages, Nurture — Xadentra",
        description: "End-to-end campaign operations: email builds, landing pages, webinar campaigns, gated content, nurture streams, retargeting, and regional rollouts.",
        path: "/services/campaign-operations",
      }}
      sections={[
        {
          heading: "Execution",
          items: [
            "Email campaign builds (modular templates, personalization)",
            "Landing page creation and conversion experiences",
            "Webinar and event campaign setup",
            "Gated asset campaigns and form strategy",
            "Retargeting landing pages and paid flows",
          ],
        },
        {
          heading: "Scale & quality",
          items: [
            "Regional campaign localization workflows",
            "QA, rendering, and accessibility checks",
            "UTM and tracking setup per campaign",
            "Launch checklists and stakeholder sign-off",
            "Post-launch reporting cadence",
          ],
        },
        {
          heading: "Programs & nurture",
          items: [
            "Multi-touch nurture program architecture",
            "Trigger-based and behavioural nurture",
            "Sales-assist nurture for stalled opportunities",
            "Segmentation strategy and dynamic content",
            "Engagement scoring and recycle paths",
          ],
        },
      ]}
      related={[
        { to: "/marketo-services", label: "Adobe Marketo Engage Services" },
        { to: "/services/managed-services", label: "Managed Services" },
        { to: "/services/reporting-attribution", label: "Reporting & Attribution" },
      ]}
    />
  );
}
